// @flow
import { makeStyles } from '@material-ui/core';
import TypographyTheme from '../../../typography/theme';
import Theme from './theme';

const useStyles = makeStyles({
  inputLabel: {
    fontFamily: TypographyTheme.fonts.sans,
    fontWeight: TypographyTheme.fontWeights.medium,
    fontSize: '0.8125rem',
    lineHeight: '1.125rem',
    transform: 'translate(1rem, 0.5rem) scale(1)',
    color: `${Theme.default.labelColor}`,
    '&&.Mui-error': {
      color: Theme.error.color,
    },
    '&&.Mui-disabled': {
      color: Theme.disabled.labelColor,
    },
  },
  requiredAsterisk: {
    color: Theme.default.requiredColor,
    '&&.Mui-error': {
      color: Theme.default.requiredColor,
    },
  },
  focusedInputLabel: {
    '&&:not(.Mui-error)': {
      color: Theme.focused.color,
    },
  },
  inputWrapper: {
    '&&&&': {
      border: `1px solid ${Theme.default.borderColor}`,
      borderRadius: '4px',
      fontFamily: TypographyTheme.fonts.sans,
      fontSize: '1rem',
      lineHeight: '1.5rem',
      color: Theme.default.color,
      backgroundColor: Theme.default.backgroundColor,
      '&&.Mui-error': {
        borderColor: Theme.error.borderColor,
      },
      '&&.Mui-disabled': {
        backgroundColor: Theme.disabled.backgroundColor,
        color: Theme.disabled.color,
      },
    },
  },
  inputWrapperUnderline: {
    '&&&:before': {
      borderBottom: 'none',
    },
    '&&:after': {
      content: '"\\00a0"',
      borderBottom: 'none',
      boxShadow: `inset 0px -2px 0px ${Theme.focused.borderBottomColor}`,
    },
    '&&.Mui-error:after': {
      transform: 'scaleX(0)',
      borderBottom: 'none',
      boxShadow: `inset 0px -2px 0px ${Theme.error.borderColor}`,
    },
    '&&.Mui-error.Mui-focused:after': {
      transform: 'scaleX(1)',
    },
  },
  htmlInput: {
    '&&&': {
      background: Theme.default.backgroundColor,
      border: `none`,
      borderRadius: '4px',
      color: `${Theme.default.color}`,
      fontSize: '1rem',
      padding: (props) =>
        props.label ? '2rem 1rem 0.625rem' : '0.625rem 1rem',
      width: '100%',
      '&.MuiInputBase-inputAdornedStart': {
        paddingLeft: '0',
      },
      '.Mui-error &&': {
        borderColor: Theme.error.borderColor,
      },
      '&&&.Mui-disabled': {
        backgroundColor: Theme.disabled.backgroundColor,
      },
      '&&::placeholder': {
        display: 'block !important',
        opacity: '1 !important',
      },
    },
  },
  adornedStart: {
    paddingLeft: '1rem',
  },
  adornedEnd: {
    paddingRight: '1rem',
  },
  helperText: {
    marginLeft: '1rem',
  },
});

export default useStyles;
